// Types
import { TYPES } from "../types/types.constants";

// Mappers
import { UserMapper, ConfigMapper } from '../../mappers';

// Constants
import { APP_CONFIG } from "../../constants";

// Actions
import { setErrorAction, setGoNoGoAction } from "./app.action";

// Services
import { AuthService, StorageService, VirtualCredentialService } from "../../services";

// Helpers
import { sendEventLogin, sendEventRecoverPassword } from "../../helpers";
import { loggerDatadog } from "../../helpers/datadog.helper";

/**
 * Autentica al usuario
 * @param {Object} userInfo El username y el password
 * @param {Function} loading Referencia a función que maneja el loading
 */
export const startLogin = (userInfo, loading) => {

    return async(dispatch) => {

        try {

            loading(true);

            const { accessToken } = await AuthService.login(userInfo.username, userInfo.password);
            const { userData, configuration } = await VirtualCredentialService.getSettings();

            StorageService.save(APP_CONFIG.STORAGE.KEYS.USER, userData);
            loggerDatadog(userInfo.username);

            dispatch(login(userData, accessToken, true));
            if (configuration != null) {

                ConfigMapper.replaceInfoConfig({ configuration });
                dispatch(setGoNoGoAction(configuration));
            }

            // Analytics
            sendEventLogin();

        } catch (error) {

            dispatch(setErrorAction(error));
        } finally {

            loading(false);
        }
    };
}

/**
 * Realiza el reseteo del password
 * @param {string} email Email del usuario
 * @param { Function } loading Función que modifica el estado del loading
 * @param { Function } showAlert Función que mostrará un mensaje notificando si se envió el email
 */
export const startResetPassword = (email, loading, showAlert) => {

    return async(dispatch) => {

        try {

            loading(true);

            await AuthService.resetPassword(email);
            showAlert();

            // Analytics
            sendEventRecoverPassword();

        } catch (error) {

            dispatch(setErrorAction(error));
        } finally {

            loading(false);
        }
    };
}

/**
 * Determina si el usuario está autenticado
 */
export const authenticatedAction = (isAuthenticated) => {

    return async(dispatch) => {

        try {

            if (isAuthenticated) {

                const userData = StorageService.load(APP_CONFIG.STORAGE.KEYS.USER);
                const accessToken = await AuthService.getAccessToken();
                if (userData) {

                    dispatch(login(userData, accessToken, false));
                }
            } else {

                dispatch(setIsAuthenticated(false));
            }

        } catch (error) {
            dispatch(setErrorAction(error));
        }
    };
}

/**
 * Guarda la información de sesión en redux
 * @param {Object} userData Información del usuario
 * @param {String} accessToken AccessToken
 * @param {*} isLogin Flag que servirá para evitar que se llame dos veces al Gonogo
 */
export const login = (userData, accessToken, isLogin) => {

    if (!userData) { return; }

    const { user } = UserMapper.transformUserInfo(userData);
    const { api } = UserMapper.transformApiInfo(accessToken);

    return {
        type: TYPES.AUTH.LOGIN,
        payload: {
            user: {
                ...user,
                permissions: api.permissions,
                isAuthenticated: true
            },
            api: {
                absolute_lifetime_expireIn: api.absolute_lifetime_expireIn
            },
            isLogin: isLogin
        }
    };
};

/**
 * Cierra la sesión limpiando el estado en el localStorage y en Redux
 */
export const logout = () => {

    AuthService.logout();
    return { type: TYPES.AUTH.LOGOUT };
};

/**
 * Resetea el estado de la propiedad Auth en Redux
 */
export const resetAuth = () => {

    return { type: TYPES.AUTH.RESET };
};

/**
 * Guarda el valor del campo Email en la página de Login
 * Necesario para recuperar dicho email en la página reset password
 * @param {String} email Email del usuario
 */
export const setEmail = (email) => {

    return {
        type: TYPES.AUTH.SET_EMAIL,
        payload: { email }
    };
};

/**
 * Guarda el valor del estado de autenticación en redux
 * @param {Boolean} isAuthenticated Flag que indica el estado de autenticación
 */
export const setIsAuthenticated = (isAuthenticated) => {

    return {
        type: TYPES.AUTH.SET_ISAUTHENTICATED,
        payload: isAuthenticated
    };
};